module.exports = __webpack_public_path__ + "img/6.8d20b712.png";